module.exports = __webpack_public_path__ + "static/media/long_read.d661c0ef.png";